import React, { useEffect } from 'react';
import { MapContainer, TileLayer, Polyline, useMap } from 'react-leaflet';
import EventMarker from './EventMarker';
import VehicleMarker from './VehicleMarker';

// Simplified component to handle map centering
const MapController = ({ routePoints, currentPosition }) => {
  const map = useMap();

  useEffect(() => {
    // Only adjust map when route data exists (user selected a ronda)
    // Don't adjust map for events - let user keep their current view
    if (routePoints && routePoints.length > 0) {
      if (routePoints.length === 1 && currentPosition) {
        // Only one point, center on it
        map.setView([currentPosition.latitude, currentPosition.longitude], 14, {
          animate: true,
          duration: 1
        });
      } else if (routePoints.length > 1) {
        // Multiple points, fit bounds to show entire route
        map.fitBounds(routePoints, {
          padding: [50, 50],
          animate: true
        });
      }
    }
    // Removed automatic adjustment for events - user can manually navigate the map
  }, [map, routePoints, currentPosition]);

  return null;
};

const Map = ({
  events = [],
  routePoints = [],
  currentPosition = null,
  rondaInfo = null,
  selectedDate = null,
  onVehicleClick = null
}) => {
  // Default center: Porto
  const defaultCenter = [41.1496, -8.6109];
  const defaultZoom = 12;

  // Format date to dd/mm/aaaa
  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString + 'T00:00:00');
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  return (
    <div className="map-container">
      {/* Date Bar */}
      {selectedDate && (
        <div className="map-date-bar">
          {formatDate(selectedDate)}
        </div>
      )}
      <MapContainer
        center={defaultCenter}
        zoom={defaultZoom}
        style={{ height: '100%', width: '100%' }}
        zoomControl={false}
        scrollWheelZoom={true}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          maxZoom={19}
        />

        <MapController
          routePoints={routePoints}
          currentPosition={currentPosition}
        />

        {/* Always render event markers when events exist */}
        {events.map(event => (
          <EventMarker
            key={`event-${event.id}`}
            event={event}
          />
        ))}

        {/* Always render route polyline when route points exist */}
        {routePoints.length > 1 && (
          <Polyline
            positions={routePoints}
            color="#dc3545"
            weight={4}
            opacity={0.7}
            smoothFactor={1}
          />
        )}

        {/* Always render vehicle marker when current position exists */}
        {currentPosition && (
          <VehicleMarker
            position={currentPosition}
            rondaInfo={rondaInfo}
            onClick={onVehicleClick}
          />
        )}
      </MapContainer>
    </div>
  );
};

export default Map;